// extracted by mini-css-extract-plugin
module.exports = {"root":"DatePickerCustom_root__2l2en","footer":"DatePickerCustom_footer__2jUuL"};